import React, { useState, useEffect } from "react";
import { Drawer } from "antd";

const AmbassadorTermsDrawer = ({
  open,
  onClose,
  onAccept,
  userProfile,
}) => {
  const [activeTermsTab, setActiveTermsTab] = useState("overview");

  useEffect(() => {
    if (open) {
      setActiveTermsTab("overview");
    }
  }, [open]);

  const handleAccept = () => {
    if (onAccept) onAccept();
    if (onClose) onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      footer={null}
      height="85vh"
      placement="bottom"
      className="rounded-t-3xl"
      title={null}
    >
      <div className="flex flex-col h-full max-w-lg mx-auto">
        <div className="flex border-b border-gray-200 pb-3 mb-4 flex-shrink-0">
          <button
            type="button"
            onClick={() => setActiveTermsTab("overview")}
            className={`flex-1 pb-2 text-sm md:text-base font-gilroyBold transition-all border-b-2 text-center cursor-pointer ${
              activeTermsTab === "overview"
                ? "border-emerald-600 text-emerald-700"
                : "border-transparent text-gray-400 hover:text-gray-600"
            }`}
          >
            Ambassador Overview
          </button>
          <button
            type="button"
            onClick={() => setActiveTermsTab("legal")}
            className={`flex-1 pb-2 text-sm md:text-base font-gilroyBold transition-all border-b-2 text-center cursor-pointer ${
              activeTermsTab === "legal"
                ? "border-emerald-600 text-emerald-700"
                : "border-transparent text-gray-400 hover:text-gray-600"
            }`}
          >
            Legal Agreement
          </button>
        </div>

        <div className="flex-1 overflow-y-auto pr-2 space-y-5 text-gray-700 pb-4">
          {activeTermsTab === "overview" ? (
            <div className="space-y-5 text-left">
              <div>
                <h3 className="text-xl font-gilroyBold text-black mb-1.5">
                  KONNECT AMBASSADOR OVERVIEW
                </h3>
                <p className="text-[13px] text-gray-600 leading-relaxed">
                  An Ambassador Portal member is a social powerhouse with 2,000+ real
                  followers across all social media platforms. Posting the
                  Konnect brand daily, Activating your audience, and Engaging
                  passionately with your followers.
                </p>
              </div>

              <div className="bg-emerald-50/50 border border-emerald-100 rounded-2xl p-4 space-y-2.5">
                <h4 className="text-base font-gilroyBold text-emerald-800 flex items-center gap-2">
                  <span>💸</span> HOW YOU EARN WEEKLY
                </h4>
                <p className="text-[13px] text-gray-800 font-gilroyBold leading-snug">
                  Pay Formula: 1% from every order + 1.5% from every business sale
                </p>
                <p className="text-[13px] text-gray-600">
                  <strong>Example:</strong> With 100+ referrals and 2 businesses
                  with 5 branches each, you and your facilitator can earn
                  ₦240k–₦280k weekly.
                </p>
                <p className="text-[13px] text-gray-600 border-t border-emerald-200/50 pt-2">
                  <strong>Milestone Rewards:</strong> Hit ₦200M total sales from the 2
                  businesses and earn: ₦1m cash every time + iPad + 6-month health
                  insurance (one-off reward).
                </p>
              </div>

              <div className="space-y-3">
                <h4 className="text-base font-gilroyBold text-red-700 flex items-center gap-2">
                  <span>🔥</span> WHAT YOU MUST DO WEEKLY
                </h4>
                <ul className="space-y-2.5 text-[13px] list-none pl-0">
                  <li className="flex gap-2">
                    <span className="font-gilroyBold text-red-600">1.</span>
                    <span>
                      <strong>Post Daily Across All Your Social Media Spaces:</strong>{" "}
                      Use your unique Konnect link every day.
                    </span>
                  </li>
                  <li className="flex gap-2">
                    <span className="font-gilroyBold text-red-600">2.</span>
                    <span>
                      <strong>Push to Achieve 20+ Verified Referrals Weekly:</strong>{" "}
                      Verified referrals = weekly cash rewards + long term earnings.
                    </span>
                  </li>
                  <li className="flex gap-2">
                    <span className="font-gilroyBold text-red-600">3.</span>
                    <span>
                      <strong>Onboard 1 Business Weekly:</strong> Restaurants,
                      Retail shops, Wholesalers — bring them into the Konnect
                      ecosystem. Every business you onboard gives you{" "}
                      <em>weekly sales income for 2 years</em>.
                    </span>
                  </li>
                </ul>
                <div className="pt-1">
                  <a
                    href="https://drive.google.com/file/d/1fv5xchEJz2ona-yNbFjn-Mkfnj9Bf3Nt/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-[#44843F] hover:bg-[#3b7337] text-white px-4 py-2.5 rounded-xl font-gilroyBold text-[13px] transition-all"
                  >
                    📈 View The Income Card
                  </a>
                </div>
              </div>

              <div className="space-y-3 border-t border-gray-100 pt-4">
                <h4 className="text-base font-gilroyBold text-black flex items-center gap-2">
                  <span>🍽️</span> HOW YOU ONBOARD RESTAURANTS
                </h4>
                <ul className="space-y-2.5 text-[13px] list-none pl-0">
                  <li className="flex gap-2">
                    <span className="font-gilroyBold text-gray-700">1.</span>
                    <span>
                      Start With Restaurants You KNOW or where you have an INSIDER
                      (manager, staff, owner) and contact us when you have a prospective business.
                    </span>
                  </li>
                  <li className="flex gap-2">
                    <span className="font-gilroyBold text-gray-700">2.</span>
                    <span>
                      We will provide you the <strong>INTRODUCTION LETTER</strong>.
                      This letter explains why Konnect is the BEST platform for them to sell.
                    </span>
                  </li>
                  <li className="flex gap-2">
                    <span className="font-gilroyBold text-gray-700">3.</span>
                    <span>
                      We give you all onboarding support and meeting assistance.
                    </span>
                  </li>
                  <li className="flex gap-2">
                    <span className="font-gilroyBold text-gray-700">4.</span>
                    <span>
                      We pay you up to ₦12,000 per location depending on the Business.{" "}
                      <span className="font-gilroyBold">
                        This applies ONLY to businesses that followed the Letter of Introduction process.
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <div className="space-y-4 text-left text-[13px] leading-relaxed text-gray-600">
              <h3 className="text-xl font-gilroyBold text-black mb-1.5">
                KONNECT AMBASSADOR AGREEMENT
              </h3>

              <p>
                This Agreement is made between Consukon Limited (owners of Konnect)
                ("The Company") and the undersigned Ambassador. The Ambassador agrees
                to all terms below.
              </p>

              <div>
                <h4 className="font-gilroyBold text-black mb-1 text-sm">1. Status</h4>
                <p>
                  The Ambassador is an independent contractor. This Agreement does
                  not create employment, partnership, or agency. The Ambassador
                  cannot bind Konnect to any obligation.
                </p>
              </div>

              <div>
                <h4 className="font-gilroyBold text-black mb-1 text-sm">2. Duties</h4>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Promote Konnect using approved materials only.</li>
                  <li>
                    Use their Account ID (Referral Code) for all referrals and
                    business onboarding.
                  </li>
                  <li>Follow Konnect's onboarding procedures and policies.</li>
                  <li>
                    Avoid false claims, misrepresentation, or unethical marketing.
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-gilroyBold text-black mb-1 text-sm">3. Compensation</h4>
                <ul className="list-disc pl-5 space-y-1">
                  <li>
                    1% income from referred user orders payable weekly.
                  </li>
                  <li>
                    1.5% income from onboarded business sales payable weekly.
                  </li>
                  <li>
                    Up to NGN 12,000 per onboarded business branch under Letter of Introduction.
                  </li>
                  <li>
                    Earnings continue for two (2) years per verified referral/onboarding.
                  </li>
                </ul>
              </div>

              <div className="border-t border-gray-200 pt-3 mt-4 space-y-1.5 bg-gray-50 p-3.5 rounded-xl">
                <h4 className="font-gilroyBold text-black mb-1.5 text-sm">SIGNATURES</h4>
                <p>
                  <strong>Ambassador Name:</strong>{" "}
                  {userProfile
                    ? `${userProfile.firstName} ${userProfile.lastName}`
                    : "______________________"}
                </p>
                <p>
                  <strong>Date:</strong>{" "}
                  {(() => {
                    const d = new Date();
                    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
                  })()}
                </p>
                <p className="mt-3 border-t border-gray-200 pt-2">
                  <strong>Signed on behalf of Consukon Limited:</strong> OO Olusegun
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="border-t border-gray-200 pt-3 mt-3 flex gap-3">
          <button
            type="button"
            onClick={handleAccept}
            className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white font-gilroyBold text-sm py-3 rounded-xl transition cursor-pointer border-0"
          >
            I Agree & Accept Terms
          </button>
          <button
            type="button"
            onClick={onClose}
            className="px-6 bg-gray-100 hover:bg-gray-200 text-gray-700 font-gilroyBold text-sm py-3 rounded-xl transition cursor-pointer border-0"
          >
            Close
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default AmbassadorTermsDrawer;
